import React from "react";
//#region types
import { RoundedIconProps } from "models/propTypes/iconPropTypes";
//#endregion
//#region components
import Icon from "./icon";
import { Grid } from "@mui/material";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const RoundedIcon: React.FC<RoundedIconProps> = (props) => {
  return (
    <Grid
      item
      className={clsx(
        cssExports.roundedBackgroundIcon,
        props.size === "small" ? cssExports.small : undefined,
        CSSHelper.getClassByDisplayType(props.displayType)
      )}
    >
      <Icon icon={props.icon} />
    </Grid>
  );
};

export default RoundedIcon;
